<template>
  <v-container>
    <h1>Conversiones Activas</h1>
    <v-row class="ma-0">
      <v-col class="pa-0 my-4">
        <v-text-field
          v-model="busqueda"
          placeholder="Buscar"
          clearable
          hide-details
          outlined
          style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
          prepend-inner-icon="mdi-magnify"
        />
      </v-col>
      <v-col class="d-flex justify-end pa-0 my-4">
        <v-btn color="black" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSXActiveForwards()">
          <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
          {{ "Descargar" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="isLoading" />
    <v-data-table class="d-none d-sm-block" :items-per-page="10" v-else hide-default-header :items="filteredActiveForwards" style="background-color: white !important">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">{{ "Id" }}</th>                                                                                                                                                                                  
            <th class="header__title center">{{ "Fecha de creación" }}</th>
            <th class="header__title center">{{ "Tipo de transaccion" }}</th>                                                                                                                                                                   
            <th class="header__title center">{{ "Fecha de vencimiento" }}</th>                                                                                                                                                                   
            <th class="header__title center">{{ "Dias faltantes" }}</th> 
            <th class="header__title center">{{ "Monto restante" }}</th>                                                                                                                                                                                                                    
            <th class="header__title center">{{ "Tipo de cambio" }}</th>
            <th class="header__title center">{{ "Monto origen" }}</th>
            <th class="header__title center">{{ "Monto destino" }}</th>
            <th class="header__title right">{{ "Acciones" }}</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">{{ item.sTransactionId }}</td>
            <td class="table__item">{{ formatDate(item.created_at) }}</td>
            <td class="table__item">
              <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" class="ma-2" color="red" outlined style="background-color: #FDF0F5 !important; border-width: 1.5px;">
                {{ "Forward" }}
              </v-chip>
              <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" class="ma-2" color="#FB0075" outlined style="background-color: #FDEBEB !important; border-width: 1.5px;">
                {{ "Window spot" }}
              </v-chip>
            </td>
            <td class="table__item">{{ formatDate(item.dForwardTransactionDate) }}</td>
            <td class="table__item">{{ item.diasFaltantes + " days" }}</td>
            <td class="table__item">{{ "$ " + formatMoney(item.dAmountRemaining) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</td>
            <td class="table__item">{{  "$ " + formatMoney(item.dExchangeRate < 1 ? 1 / item.dExchangeRate : item.dExchangeRate) + " MXN" }}</td>
            <td class="table__item">{{ "$ " + formatMoney(item.dAmount) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</td>
            <td class="table__item">{{ "$ " + formatMoney(item.dDesAmount) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</td>
            <td class="table__item">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="dialogRequestPayment = true, forward = item" :disabled="item.diasFaltantes > 0 || !permissionList.includes('requestPayment') || item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-cash-sync</v-icon>
                  </v-btn>
                </template>
                <span>{{ "Solicitar Cobro" }}</span> 
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="showStatusModal = true, forward = item" :disabled="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3' || !permissionList.includes('updateConversion')" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ "Actualizar status" }}</span> 
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-dialog v-if="dialogRequestPayment" v-model="dialogRequestPayment" persistent max-width="fit-content">
      <v-card>
        <v-card-title class="text-h5" style="font-family: 'montserrat-bold' !important;">{{ '¿Estás seguro de que deseas solicitar el pago total del forward?' }}</v-card-title>
        <v-card-text v-if="!loading" class="mt-6" style="font-family: 'montserrat-semibold';">
          {{ 'Una vez que realizas la transacción se revisará que tu saldo USD sea suficiente para pagar el total del forward.' }}
        </v-card-text>
        <v-card-text v-if="!loading" class="mb-6" style="font-family: 'montserrat-semibold';">
          {{ 'El monto se irá a la pestaña de saldo disponible MXN.' }}
        </v-card-text>
        <div v-else style="display: flex; justify-content: center;">
          <v-progress-circular indeterminate color="#193D6E"></v-progress-circular>
        </div>
         <v-card-actions class="pb-4" style="justify-content: space-evenly;">
          <v-btn
            color="black"
            elevation="8"
            class="mr-2 px-6"
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="loading"
            @click="dialogRequestPayment = false, forward = null"
          >
            {{ 'Cancel' }}
          </v-btn>
          <v-btn
            color="black"
            elevation="8"
            class="white--text px-6"
            style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
            @click="requestPayment()"
          >
            {{ 'Confirm' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showStatusModal" max-width="700px" persistent>
      <v-card class="" style="width: 100%">
        <div style="display: flex; flex-direction: column; align-items: center;">
          <v-card-title class="text-h5 my-4 mt-0 mx-4 pt-10 pb-6 px-4" style="border-radius: 10px; background-color: black; color: white; font-family: 'montserrat-semibold' !important; text-align: center; width: 100%; display: flex; justify-content: center;">
            La conversión cambiará a estatus: Concretada
          </v-card-title>
          <v-card-text v-if="!isChangingStatus" class="mt-4" style="text-align: center; font-family: 'montserrat-semibold'; font-size: 18px;">Estás por marcar esta conversión como concretada.</v-card-text>
          <div v-else style="display: flex; justify-content: center;">
            <v-progress-circular
              indeterminate
              color="red"
            ></v-progress-circular>
          </div>
        </div>
        <v-card-actions class="pb-4 mt-8" style="justify-content: space-evenly;">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="mr-2 px-6"
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="isChangingStatus"
            @click="showStatusModal = false"
          >
            {{ "Cancelar" }}
          </v-btn>
          <v-btn
            color="black"
            elevation="8"
            class="white--text px-6"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
            :disabled="isChangingStatus || !permissionList.includes('updateConversion')"
            @click="confirmStatusChange()"
          >
            {{ "Aceptar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import moment from "moment";
  export default {
    name: "ConversionesActivas",
    props: {
      activeTab: String,
      permissionList: Array,
      enterprise: Object
    },
    data() {
      return {
        activeConversionsRaw: [],
        loading: false,
        busqueda: "",
        isLoading: false,
        dialogRequestPayment: false,
        showStatusModal: false,
        isChangingStatus: false,
        forward: null,
      };
    },
    watch: {
      activeTab(val) {
        if (val === 'conversionesActivas') {
          this.getActiveConversions();
        }
      }
    },
    computed: {
      filteredActiveForwards() {
        if (!this.busqueda) return this.activeConversionsRaw;

        const filtro = this.busqueda.toLowerCase();

        return this.activeConversionsRaw.filter((item) => {
          const tipo = this.getTransactionTypeName(item.sTransactionType).toLowerCase();
          const fechaCreacion = this.formatDate(item.created_at).toLowerCase();
          const fechaForward = item.dForwardTransactionDate ? this.formatDate(item.dForwardTransactionDate).toLowerCase() : "-";
          const diasFaltantes = `${item.diasFaltantes} days`.toLowerCase();
          const montoRestante = `$ ${this.formatMoney(item.dAmountRemaining)} ${item.sCurrency || 'USD'}`.toLowerCase();
          const tipoCambio = `$ ${this.formatMoney(item.dExchangeRate < 1 ? 1 / item.dExchangeRate : item.dExchangeRate)} MXN`.toLowerCase();
          const montoOrigen = `$ ${this.formatMoney(item.dAmount)} ${item.sCurrency || 'USD'}`.toLowerCase();
          const montoDestino = `$ ${this.formatMoney(item.dDesAmount)} ${item.sDestCurrency || 'MXN'}`.toLowerCase();

          return (
            String(item.iTrackingId).toLowerCase().includes(filtro) ||
            fechaCreacion.includes(filtro) ||
            tipo.includes(filtro) ||
            fechaForward.includes(filtro) ||
            diasFaltantes.includes(filtro) ||
            montoRestante.includes(filtro) ||
            tipoCambio.includes(filtro) ||
            montoOrigen.includes(filtro) ||
            montoDestino.includes(filtro)
          );
        });
      }
    },
    mounted() {
      if (this.activeTab === 'conversionesActivas') {
        this.getActiveConversions();
      }
    },
    methods: {
      getActiveConversions() {
        this.isLoading = true;
        this.activeConversionsRaw = [];
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };

        DB.post(`${URI}/api/v1/en/administrator/forwardsActive`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.activeConversionsRaw = response.data.forwards;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      getTransactionTypeName(id) {
        switch (id) {
          case 'b80e8dc6-4138-449e-8903-968efb8437b3': return 'Forward';
          case '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf': return 'Window spot';
          default: return 'N/A';
        }
      },
      dataXLSXActiveForwards() {
        try {
          const data = this.activeConversionsRaw.map((item) => ({
            "ID de seguimiento": item.sTransactionId || "-",
            "Fecha de creación": item.created_at ? this.formatDate(item.created_at) : "-",
            "Tipo de transacción": this.getTransactionTypeName(item.sTransactionType),
            "Fecha forward": item.dForwardTransactionDate ? this.formatDate(item.dForwardTransactionDate) : "-",
            "Días faltantes": `${item.diasFaltantes} días`,
            "Monto restante": `$ ${this.formatMoney(item.dAmountRemaining)} ${item.sCurrency || 'USD'}`,
            "Tipo de cambio": `$ ${this.formatMoney(item.dExchangeRate < 1 ? 1 / item.dExchangeRate : item.dExchangeRate)} MXN`,
            "Monto origen": `$ ${this.formatMoney(item.dAmount)} ${item.sCurrency || 'USD'}`,
            "Monto destino": `$ ${this.formatMoney(item.dDesAmount)} ${item.sDestCurrency || 'MXN'}`,
          }));

          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Conversiones Activas");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          saveAs(blob, "Conversiones_Activas.xlsx");

          this.success = true;
          this.msgSuccess = "Descargando conversiones activas";
        } catch (error) {
          console.error("Error al generar XLSX de conversiones activas:", error);
          this.error = true;
          this.codeError = "XLSX_ACTIVE_FORWARDS_FAILED";
        }
      },
      async requestPayment() {
        this.loading = true;
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          sTransactionId: this.forward.sTransactionId,
        };

        DB.post(
          `${URI}/api/v1/en/administrator/requestPayment`,
          payload,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        )
        .then((response) => {
          this.getActiveConversions();
          this.forward = null;
          this.$emit('wallets:update');
          this.dialogRequestPayment = false;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.forward = null;
          this.dialogRequestPayment = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      async confirmStatusChange() {
        this.isChangingStatus = true;
        const transactionId = this.forward.sTransactionId;
        
        try {
          const response = await DB.put(`${URI}/api/v1/en/administrator/conversion/${transactionId}/status`, {
            sStatusId: '5a792637-1103-4a89-8f67-86c49b93e227',
            sEnterpriseId: this.$route.params.sEnterpriseId,
          }, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          });

          if (response.data.success) {
            this.showStatusModal = false;
            
            this.getActiveConversions();
            this.mixSuccess(response.data.message);
          }
        } catch (error) {
          console.error('Error al cambiar status:', error);
          if (error.response?.data?.message) {
            this.mixError(error.response.data.message, error.response.status);
          } else {
            this.mixError('Error al cambiar el status de la conversión');
          }
        } finally {
          this.isChangingStatus = false;
        }
      },
    }
  };
</script>
<style scoped>
</style>